(ns manage.adset-decision-tree-page.view.side-panel.core
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tab$default" :as Tab]
            ["@mui/material/Tabs$default" :as Tabs]
            ["@mui/material/Typography$default" :as Typography]
            [manage.adset-decision-tree-page.event :as event]
            [manage.adset-decision-tree-page.selection :as selection]
            [manage.adset-decision-tree-page.sub :as sub]
            [manage.adset-decision-tree-page.view.common
             :refer [decision-tree-node-container node-header]]
            [manage.adset-decision-tree-page.view.constant
             :refer [palette-node-mime-type]]
            [manage.adset-decision-tree-page.view.context :as context]
            [manage.adset-decision-tree-page.view.side-panel.selection-detail
             :as detail]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- on-drag-start [^js event node-type]
  (.. event -dataTransfer (setData palette-node-mime-type node-type))
  (set! (.. event -dataTransfer -effectAllowed) "copy"))

(defui palette-item [{{:keys [description]
                       node-type :type
                       :as node-data} :node-data}]
  (let [[is-dragging set-is-dragging] (uix/use-state false)]
    ($ decision-tree-node-container
       {:paper-props {:draggable true
                      :onDragStart (fn [^js event]
                                     (set-is-dragging true)
                                     (on-drag-start event node-type))
                      :onDragEnd (fn [^js _event]
                                   (set-is-dragging false))}

        :sx #js {:width "auto"
                 "&:hover" #js {:boxShadow 6}
                 :cursor (if is-dragging "grabbing" "grab")}}
       ($ Stack {:direction "row"
                 :spacing 1}
          ($ Icon {}
             "drag_indicator")
          ($ Stack {:spacing 1.5
                    :sx #js {:minWidth 0}}
             ($ node-header {:node-data node-data})
             ($ Typography {:overflow "hidden"
                            :textOverflow "ellipsis"
                            :whiteSpace "nowrap"
                            :sx #js {:color "text.secondary"}}
                description))))))

(defui palette []
  (let [{:keys [available-nodes]} (uix/use-context context/decision-trees-context)]
    ($ Stack {:px 1.5
              :py 3
              :spacing 2}
       (for [{item-key :type :as child-configuration}
             (filter (comp #{:decision-node} :category) available-nodes)]
         ($ palette-item {:key item-key
                          :node-data child-configuration})))))

(defui header-label [{:keys [decision-node-id type] :as _selected-item}]
  (let [{decision-node-name :name} (use-subscribe [::sub/node-data decision-node-id])]
    (if (some? type)
      (case type
        :selection/decision-node (str decision-node-name " Strategy")
        :selection/outcome-node (str decision-node-name " Outcome")
        :selection/variant "Tagging & Trackers"
        :selection/product-selector "Products"
        :selection/default-outcome-node (str "Default (" decision-node-name ")"))
      "Strategy")))

(defui side-panel-header []
  (let [selected-item (use-subscribe [::sub/first-selected-item])
        parent-selected-item (selection/parent-selected-item selected-item)]
    ($ Stack {:direction "row"
              :alignItems "center"
              :borderBottom 1
              :borderColor "grey.60"
              :sx #js {:pl 2}}
       (when (some? selected-item)
         ($ IconButton
            {:on-click (fn [^js _event]
                         (if (nil? parent-selected-item)
                           (rf/dispatch [::event/set-selection []]) ; Clears the selection
                           (rf/dispatch [::event/set-selection [parent-selected-item]])))}
            ($ Icon (if (nil? parent-selected-item)
                      "close"
                      "keyboard_backspace"))))
       ($ Tabs {:value 0}
          ($ Tab {:label ($ header-label selected-item)
                  :sx #js {:height 50}})))))

(defui side-panel []
  (let [first-selected-item (use-subscribe [::sub/first-selected-item])]
    ($ Stack {:component "aside"
              :backgroundColor "background.paper"
              :color "text.primary"
              :height "100%"}
       ($ side-panel-header)
       ($ Box {:sx #js {:overflowY "auto"
                        :flexGrow 1}}
          (if (some? first-selected-item)
            ($ detail/root-view)
            ($ palette))))))
